<div class="login-parent-division col-xl-12 no-padding">
    <div class="row m-0 login-sec">
        <div class="login-left-section col-xl-3 col-lg-4 col-md-12 col-12 p-0">
            <div class="lls-tp_img">
                <!-- <img src="../../../assets/images/logo1.png"> -->
            </div>
            <div class="lls-caption">
                <h2><strong>Welcome to</strong> <img src="../../../assets/images/logo1.png"></h2>
                <p>Pushing boundaries to provide the best products and services to you since 1967</p>
                <div class="arrow_img_section">
                    <img src="../../assets/images/Poly_1.png">
                    <img src="../../assets/images/Poly_2.png">
                    <img src="../../assets/images/Poly_3.png">
                </div>
            </div>
            <div class="lld_img-section">
                <img src="../../assets/images/login_left_down.png">
            </div>
        </div>
        <div class="login-right-section col-xl-9 col-lg-8 col-md-12 col-12 p-0">
            <div class="login-base-section">
                <div class="form-section">
                    <h4>{{'Login' }}</h4>
                    <span>{{'Note: Please enter the Mobile number and PAN# used during registration to login to your account ' }}</span>
                    <!-- <span style="color: #FCBA13; width: 110%;"> Note: Please enter the Mobile number and PAN# used during registration to login to your account </span> -->
                    <form #f="ngForm" [formGroup]="loginForm" (ngSubmit)="loginForm.valid && loginFun()">

                        <div class="form-control">

                            <input type="text" placeholder="{{'Enter Phone Number *'}}" oninput="this.value=this.value.replace(/[^0-9]/g,'');" formControlName="mobileNo" maxlength="10" />
                            <div class="er-msg" *ngIf="loginForm.controls.mobileNo.errors?.minlength"> Phone Number Must be 10 Digits</div>
                            <div class="er-msg" *ngIf="f.submitted && loginForm.controls.mobileNo.errors?.required"> Phone Number Required</div>

                            <span class="icon-span"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                  fill="none">
                  <path
                    d="M19.9981 16.1154C19.9702 15.3418 19.6479 14.6198 19.0907 14.0825C17.9997 13.0304 17.0855 12.4231 16.2139 12.1712C15.0129 11.8241 13.9004 12.1397 12.9076 13.1093C12.9061 13.1108 12.9046 13.1123 12.9031 13.1137L11.8469 14.1621C11.1868 13.79 9.90318 12.973 8.51638 11.5862L8.41357 11.4834C7.02654 10.0964 6.20955 8.81261 5.83779 8.15324L6.88623 7.09695C6.88771 7.09546 6.88919 7.09398 6.89068 7.09245C7.86025 6.09972 8.17587 4.9873 7.8288 3.78617C7.57689 2.91456 6.96958 2.00042 5.91747 0.909369C5.38021 0.35222 4.6583 0.0299547 3.88466 0.00206406C3.11056 -0.0258656 2.36775 0.243588 1.79165 0.760697L1.76923 0.780853C1.75884 0.790189 1.74869 0.799838 1.73876 0.80972C0.591928 1.95656 -0.00924414 3.56206 0.000169925 5.45273C0.0162246 8.66453 1.78142 12.3375 4.72201 15.278C5.2765 15.8325 5.90669 16.3813 6.59505 16.9091C6.93744 17.1716 7.42783 17.1069 7.69037 16.7645C7.95294 16.4221 7.88818 15.9317 7.54576 15.6691C6.91158 15.1828 6.33326 14.6796 5.82685 14.1733C3.17076 11.5172 1.57665 8.25429 1.56263 5.44495C1.5554 3.98886 1.99341 2.77351 2.82947 1.92874L2.83544 1.92335C3.4033 1.41363 4.26302 1.44464 4.79279 1.99398C6.8154 4.09156 6.66896 5.08183 5.77521 5.99831L4.32701 7.45738C4.0999 7.6862 4.03665 8.03105 4.16779 8.32558C4.20455 8.40816 5.09396 10.3735 7.309 12.5885L7.41185 12.6912C9.62662 14.906 11.592 15.7954 11.6746 15.8322C11.969 15.9634 12.314 15.9001 12.5427 15.673L14.0019 14.2248C14.9185 13.331 15.9087 13.1846 18.0062 15.2072C18.5555 15.7369 18.5865 16.5967 18.0769 17.1644L18.0714 17.1706C17.2335 17.9998 16.0311 18.4375 14.5909 18.4375C14.579 18.4375 14.5671 18.4375 14.5552 18.4374C13.404 18.4317 12.0709 18.1161 10.7002 17.5248C10.3041 17.3539 9.84427 17.5366 9.67341 17.9328C9.50251 18.329 9.68513 18.7887 10.0813 18.9596C11.6658 19.643 13.1684 19.993 14.5474 19.9999C14.5621 20 14.5766 20 14.5913 20C16.4629 20 18.0525 19.3993 19.1904 18.2613C19.2003 18.2514 19.2099 18.2413 19.2193 18.2309L19.2395 18.2083C19.7566 17.6323 20.026 16.889 19.9981 16.1154Z"
                    fill="#FCBA13" />
                </svg>
              </span>
                        </div>
                        <div class="form-control">

                            <!-- <input type="text" placeholder="{{'Enter PAN Number *'}}" oninput="this.value=this.value.replace(/[^a-zA-Z0-9]/g,'');" formControlName="panNumber" maxlength="10" /> -->
                            <input type="text" placeholder="{{'Enter PAN Number *'}}" (input)="panValidation($event)" formControlName="panNumber" maxlength="10" />
                            <!-- <div class="er-msg" *ngIf="loginForm.controls.panNumber.errors?.minlength"> PAN Number Must be 10 Digits</div> -->
                            <!-- <div class="er-msg" *ngIf="loginForm.controls.panNumber.errors?.pattern ">Invalid PAN Number Format </div> -->
                            <div class="er-msg" *ngIf="loginForm.controls.panNumber.errors?.pattern">Invalid PAN Number Format </div>

                            <div class="er-msg" *ngIf="f.submitted && loginForm.controls.panNumber.errors?.required"> PAN Number Required</div>

                            <span class="icon-span"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="28" viewBox="0 0 20 28"
                  fill="none">
                  <path
                    d="M12.7272 10.1212C12.7272 8.61738 11.5038 7.39392 9.99998 7.39392C8.49616 7.39392 7.27271 8.61738 7.27271 10.1212C7.27271 11.625 8.49616 12.8485 9.99998 12.8485C11.5038 12.8485 12.7272 11.625 12.7272 10.1212ZM9.99998 11.0303C9.4987 11.0303 9.09089 10.6225 9.09089 10.1212C9.09089 9.61992 9.4987 9.2121 9.99998 9.2121C10.5013 9.2121 10.9091 9.61992 10.9091 10.1212C10.9091 10.6225 10.5013 11.0303 9.99998 11.0303Z"
                    fill="#A5A5A5" />
                  <path
                    d="M9.99998 12.8485C7.49362 12.8485 5.45453 14.8876 5.45453 17.394V20.1212H14.5454V17.394C14.5454 14.8876 12.5063 12.8485 9.99998 12.8485ZM12.7273 18.3031H7.27271V17.394C7.27271 15.8901 8.49617 14.6667 9.99998 14.6667C11.5038 14.6667 12.7273 15.8901 12.7273 17.394V18.3031Z"
                    fill="#A5A5A5" />
                  <path d="M5.45453 21.9395H14.5454V23.7576H5.45453V21.9395Z" fill="#A5A5A5" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0 27.2121V0H20V27.2121H0ZM1.81818 25.3939V1.75758H7.27273V5.39394H12.7273V1.75758H18.1818V25.3939H1.81818Z"
                    fill="#A5A5A5" />
                </svg>
              </span>
                        </div>
                        <div class="form-control checkbox-division">
                            <p>
                                <input type="radio" value="Password" id="test1" formControlName="loginType">
                                <label for="test1"> {{"I have Password" }} </label>
                            </p>
                            <p>
                                <input type="radio" value="OTP" id="test2" formControlName="loginType" (click)="loginFuncForOtp()" [attr.disabled]="otpSuccess && loginForm.value.loginType == 'OTP' ? '' : null">
                                <label for="test2">{{'Send OTP BY SMS' }} </label>
                            </p>
                        </div>
                        <div class="form-control form-control-password" *ngIf="loginForm.value.loginType == 'Password'">
                            <button (click)="clicktooglePassword()" type="button" class="toggle-password-button">
                <i class="fa fa-eye" aria-hidden="true" *ngIf="show"></i>
                <i class="fa fa-eye-slash" aria-hidden="true" *ngIf="!show"></i>
              </button>
                            <input [type]="password" placeholder="{{'ENTER PASSWORD *'}}" formControlName="password" maxlength="16" />
                            <span class="icon-span"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                  fill="none">
                  <g clip-path="url(#clip0)">
                    <path
                      d="M15.625 20H4.375C3.34167 20 2.5 19.1592 2.5 18.125V9.375C2.5 8.34083 3.34167 7.5 4.375 7.5H15.625C16.6583 7.5 17.5 8.34083 17.5 9.375V18.125C17.5 19.1592 16.6583 20 15.625 20ZM4.375 8.75C4.03083 8.75 3.75 9.03 3.75 9.375V18.125C3.75 18.47 4.03083 18.75 4.375 18.75H15.625C15.9692 18.75 16.25 18.47 16.25 18.125V9.375C16.25 9.03 15.9692 8.75 15.625 8.75H4.375Z"
                      fill="#FCBA13" />
                    <path
                      d="M14.375 8.75C14.03 8.75 13.75 8.47 13.75 8.125V5C13.75 2.9325 12.0675 1.25 10 1.25C7.9325 1.25 6.25 2.9325 6.25 5V8.125C6.25 8.47 5.97 8.75 5.625 8.75C5.28 8.75 5 8.47 5 8.125V5C5 2.2425 7.2425 0 10 0C12.7575 0 15 2.2425 15 5V8.125C15 8.47 14.72 8.75 14.375 8.75Z"
                      fill="#FCBA13" />
                    <path
                      d="M10 14.1666C9.08087 14.1666 8.33337 13.4191 8.33337 12.5C8.33337 11.5808 9.08087 10.8333 10 10.8333C10.9192 10.8333 11.6667 11.5808 11.6667 12.5C11.6667 13.4191 10.9192 14.1666 10 14.1666ZM10 12.0833C9.77087 12.0833 9.58337 12.27 9.58337 12.5C9.58337 12.73 9.77087 12.9166 10 12.9166C10.2292 12.9166 10.4167 12.73 10.4167 12.5C10.4167 12.27 10.2292 12.0833 10 12.0833Z"
                      fill="#FCBA13" />
                    <path
                      d="M10 16.6667C9.655 16.6667 9.375 16.3867 9.375 16.0417V13.75C9.375 13.405 9.655 13.125 10 13.125C10.345 13.125 10.625 13.405 10.625 13.75V16.0417C10.625 16.3867 10.345 16.6667 10 16.6667Z"
                      fill="#FCBA13" />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
  
                </svg></span>
                        </div>

                        <div class="form-control form-control-password" *ngIf="loginForm.value.loginType == 'OTP'">
                            <input type="text" placeholder="{{'ENTER OTP *' }}" maxlength="5" oninput="this.value=this.value.replace(/[^0-9]/g,'');" formControlName="otp" />
                            <span class="icon-span"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
                  fill="none">
                  <g clip-path="url(#clip0)">
                    <path
                      d="M15.625 20H4.375C3.34167 20 2.5 19.1592 2.5 18.125V9.375C2.5 8.34083 3.34167 7.5 4.375 7.5H15.625C16.6583 7.5 17.5 8.34083 17.5 9.375V18.125C17.5 19.1592 16.6583 20 15.625 20ZM4.375 8.75C4.03083 8.75 3.75 9.03 3.75 9.375V18.125C3.75 18.47 4.03083 18.75 4.375 18.75H15.625C15.9692 18.75 16.25 18.47 16.25 18.125V9.375C16.25 9.03 15.9692 8.75 15.625 8.75H4.375Z"
                      fill="#FCBA13" />
                    <path
                      d="M14.375 8.75C14.03 8.75 13.75 8.47 13.75 8.125V5C13.75 2.9325 12.0675 1.25 10 1.25C7.9325 1.25 6.25 2.9325 6.25 5V8.125C6.25 8.47 5.97 8.75 5.625 8.75C5.28 8.75 5 8.47 5 8.125V5C5 2.2425 7.2425 0 10 0C12.7575 0 15 2.2425 15 5V8.125C15 8.47 14.72 8.75 14.375 8.75Z"
                      fill="#FCBA13" />
                    <path
                      d="M10 14.1666C9.08087 14.1666 8.33337 13.4191 8.33337 12.5C8.33337 11.5808 9.08087 10.8333 10 10.8333C10.9192 10.8333 11.6667 11.5808 11.6667 12.5C11.6667 13.4191 10.9192 14.1666 10 14.1666ZM10 12.0833C9.77087 12.0833 9.58337 12.27 9.58337 12.5C9.58337 12.73 9.77087 12.9166 10 12.9166C10.2292 12.9166 10.4167 12.73 10.4167 12.5C10.4167 12.27 10.2292 12.0833 10 12.0833Z"
                      fill="#FCBA13" />
                    <path
                      d="M10 16.6667C9.655 16.6667 9.375 16.3867 9.375 16.0417V13.75C9.375 13.405 9.655 13.125 10 13.125C10.345 13.125 10.625 13.405 10.625 13.75V16.0417C10.625 16.3867 10.345 16.6667 10 16.6667Z"
                      fill="#FCBA13" />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="20" height="20" fill="white" />
                    </clipPath>
                  </defs>
                </svg></span>
                        </div>

                        <div class="form-control checkbox-division" *ngIf="loginForm.value.loginType == 'OTP'">

                            <p *ngIf="otpSuccess">
                                <!-- <input type="radio" id="test1" name="radio-group" > -->
                                <label><b>{{"Otp Send to Register Mobile Number"}}</b> <a (click)="sendOtp()">{{phoneNoMask(loginForm.value.mobileNo)}}</a></label>
                            </p>
                            <p>
                                <!-- <input type="radio" id="test1" name="radio-group" > -->
                                <label><b> {{"DIDN'T RECEIVE OTP?" }} </b> <a (click)="sendOtp()">{{"RESEND OTP" 
                  }}</a></label>
                            </p>

                        </div>
                        <div class="form-control anchor-section">
                            <a (click)="_route_reset()">{{"Reset Password?" }} </a>
                            <!-- <button (click)="GAevent()"> GA</button> -->
                        </div>
                        <div class="form-control login-btn" *ngIf="loginForm.value.loginType == 'Password'">
                            <button class="btn-login-btn btn">{{"Login" }}</button>
                        </div>
                        <div class="form-control login-btn" *ngIf="loginForm.value.loginType == 'OTP'">
                            <button class="btn-login-btn btn" type="button" (click)="otpVerification()"> {{'Login'}}</button>
                        </div>
                        <div class="form-control final-reg-btn ">
                            <span class="justify-content-center"><b>{{"Don’t have an account?"}}</b> <a
                  routerLink="/register">{{"Register"}}</a></span>
                        </div>
                    </form>
                </div>


            </div>
            <div class="lrs-footer">

                <div class="lrs-footer-sec-one">
                    <div class="mobile-app text-center text-white">
                        Download Mobile APP for Better Experience
                    </div>
                    <div class="app-play-img-sec">
                        <a href="https://apps.apple.com/in/app/gmmcoassist/id1580235771" target="_blank"><img src="../../assets/images/app-store.png"></a>
                        <a href="https://play.google.com/store/apps/details?id=com.app.gmmcoassist" target="_blank"><img src="../../assets/images/google-play.png"></a>
                    </div>

                </div>
                <div class="foot-cont">
                    <!-- <h4>{{'Follow Us On'|translate}}</h4> -->
                    <ul class="list-inline mt-1">
                        <li class="list-inline-item"><a href="https://www.facebook.com/gmmcoproducts" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                        <li class="list-inline-item"><a href="https://twitter.com/gmmco_cat" target="_blank"><i class="fab fa-twitter"></i></a></li>
                        <li class="list-inline-item"><a href="https://www.linkedin.com/company/gmmco-ltd" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                        <li class="list-inline-item"><a href="https://www.youtube.com/channel/UCN7EyeQ1qjmft1Jc2GtH7xw" target="_blank"><i class="fab fa-youtube" style="color: white;"></i></a></li>
                        <li class="list-inline-item">
                            <a href="https://www.gmmco.in/gmmco-cat/" target="_blank"> <i class="fas fa-globe"></i></a>
                        </li>

                    </ul>
                </div>
                <div class="lrs-footer-sec-three">
                    <div class="app-play-img-sec">
                        <a href="tel:123-456-7890p123"><i class="fa fa-phone" aria-hidden="true"></i> 
                         
                          1800-425-2546 |</a>
                        <span>Chat 16*7</span>
                    </div>
                    <a class="hr-link" href="{{envVar.baseUrl}}RegHelp/HowtoRegister2.pdf" target="_blank">How to Register ?</a>
                </div>
            </div>
        </div>
    </div>

</div>

<ng-template #mymodal let-modal>
    <div class="modal-body p-0">
        <div class="login-popup-pnt lpp-hmpg-popup py-3">
            <div class="login-popup-pnt-left col-md-3">
                <img class="w-100" src="../../assets/images/hmpg-popup-logo.png" />
            </div>
            <p>
                Your password is expired, Click OK to change password now.
            </p>


        </div>
        <button type="button" class="btn btn-pay-now mb-3 me-4" (click)="modalClose()" style="float: right;">Ok</button>
    </div>
</ng-template>

<ng-template #mymodal2 let-modal>
    <!-- <div class="modal-body text-center">
        <p>
            Your password is expired, Click OK to change password now.
        </p>
        <button type="button" class="btn btn-outline-dark" (click)="modalClose()">Ok</button>
    </div> -->
    <div class="modal-body p-0">
        <div class="login-popup-pnt lpp-hmpg-popup py-3">
            <div class="login-popup-pnt-left col-md-3">
                <img class="w-100" src="../../assets/images/hmpg-popup-logo.png" />
            </div>
            <p>
                Your password is expired, Click OK to change password now.
            </p>


        </div>
        <button type="button" class="btn btn-pay-now mb-3 me-4 " (click)="modalClose()" style="float: right;">Ok</button>
    </div>
</ng-template>